




































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import BreadcrumbComponent from '@/_shared/components/layout/breadcrumb.component.vue';
import InsightCard from '@/monitor/components/downline-builder-bonus/insight-card.component.vue';
import DownlineBuilderBonusInsight from '@/monitor/entities/downline-builder-bonus/downline-builder-bonus-insight.entity';
import InfoIcon from '@/_shared/components/icons/info-icon.component.vue';
import DownlineBuilderBonusService from '@/monitor/services/downline-builder-bonus/downline-builder-bonus.service';
import NoResults from '@/_shared/components/globals/no-results.component.vue';
import DownlineList from '@/monitor/components/downline-builder-bonus/downline-list.component.vue';
import DownlineLevel from '@/monitor/interfaces/downline-builder-bonus/downline-level.interface';
import EventBusService from '@/_shared/services/event-bus/event-bus.service';
import LoadingEvent from '@/monitor/events/downline-builder-bonus/loading.event';

@Component({
  components: {
    DownlineList,
    NoResults,
    BreadcrumbComponent,
    InfoIcon,
    InsightCard,
  },
})
export default class DownlineBuilderBonus extends Vue {
  insights: DownlineBuilderBonusInsight[] = [];
  lazyLoadedTabs = new Set<number>([0]);
  selectedTab = 0;
  loadingCount = 0;

  get levels(): DownlineLevel[] {
    return this.insights.map((insight) => {
      const isLastLevel = insight.level === this.lastLevel;
      const label = isLastLevel
        ? `${insight.minimumQv}+`
        : `${insight.minimumQv} - ${insight.maximumQv}`;
      return {
        level: insight.level,
        label,
        repAchieved: insight.repAchieved,
      };
    });
  }

  get selectedLevel(): DownlineLevel | undefined {
    return this.levels.find((level) => level.level === this.selectedTab);
  }

  get lastLevel(): number | undefined {
    const lastItem = this.insights[this.insights.length - 1];
    return lastItem?.level;
  }

  scrollTopOnList(): void {
    const listTitle: HTMLElement = document.getElementById('list-title') as HTMLElement;
    const scrollTop = listTitle?.offsetTop;
    if (!scrollTop) return;
    const offset = 20;
    window.scrollTo({
      top: scrollTop + offset,
      left: 0,
      behavior: 'smooth',
    });
  }

  selectTab(level: number) {
    this.selectedTab = level;
    this.addLazyLoadedTab(level);
  }

  isTabNotLazyLoaded(level: number): boolean {
    return !this.lazyLoadedTabs.has(level);
  }

  addLazyLoadedTab(level: number): void {
    this.lazyLoadedTabs.add(level);
    this.$forceUpdate();
  }

  getInsights(): Promise<void> {
    return DownlineBuilderBonusService.getInsights(this.$store.state.RepStore.rep.did)
      .then((response) => {
        this.insights = response;
      });
  }

  async retrieveData(): Promise<void> {
    this.addLoading();
    try {
      await this.getInsights();
    } finally {
      this.removeLoading();
    }
  }

  addLoading(): void {
    this.loadingCount += 1;
  }

  removeLoading(): void {
    this.loadingCount -= 1;
  }

  created() {
    this.retrieveData();
    EventBusService.on(LoadingEvent.SHOW, this.addLoading);
    EventBusService.on(LoadingEvent.HIDE, this.removeLoading);
  }

  beforeDestroy() {
    EventBusService.off(LoadingEvent.SHOW, this.addLoading);
    EventBusService.off(LoadingEvent.HIDE, this.removeLoading);
  }

  @Watch('loadingCount')
  onChangeLoadingCount(count: number): void {
    if (count > 0) {
      this.$store.dispatch('showLoading');
      return;
    }
    this.$store.dispatch('hideLoading');
  }
}
